// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__29qwt","sectionsWrapper":"style_sectionsWrapper__l7HBZ"};